export enum PlatformMode {
  APP = 'APP',
  WEB = 'WEB',
}
